<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="htp02">
<h2 class="halfTitlePageTitle"><span class="bold">Hungry Girl 1-2-3</span></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// hungrygirl123_htp02.vue?2cc1df35